import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import useCreate from "../../../hooks/useCreate";
import Spinner from "../../../components/spinner";
import toast from "react-hot-toast";

function QuickUpdatePriceModal({ open, onClose, product, onSuccess }) {
  const [formData, setFormData] = useState({
    mrp_price: "",
    selling_price: "",
    business_selling_price: "",
  });

  useEffect(() => {
    if (product) {
      setFormData({
        mrp_price: product.mrp_price ?? "",
        selling_price: product.selling_price ?? "",
        business_selling_price: product.business_selling_price ?? "",
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const { setDataToServer } = useCreate({
    url: "product/price-update",
    refreshUrl: "product/list",
    onSuccess: () => {
      toast.success("Prices updated successfully");
      onSuccess?.();
      onClose();
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error updating prices");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!product?.id) return;

    const payload = {
      id: product.id,
      mrp_price: formData.mrp_price,
      selling_price: formData.selling_price,
      business_selling_price: formData.business_selling_price,
    };

    setDataToServer.mutate(payload);
  };

  if (!product) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Quick Update Prices - {product.product_name}</DialogTitle>
        <DialogContent className="pt-4 space-y-4">
          <div>
            <label htmlFor="mrp_price" className="label">
              MRP Price <small className="text-red-700">*</small>
            </label>
            <input
              type="number"
              required
              step="0.01"
              min="0"
              placeholder="Enter MRP Price"
              name="mrp_price"
              id="mrp_price"
              className="input w-full"
              value={formData.mrp_price}
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor="selling_price" className="label">
              Selling Price <small className="text-red-700">*</small>
            </label>
            <input
              type="number"
              required
              step="0.01"
              min="0"
              placeholder="Enter Selling Price"
              name="selling_price"
              id="selling_price"
              className="input w-full"
              value={formData.selling_price}
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor="business_selling_price" className="label">
              Business Selling Price <small className="text-red-700">*</small>
            </label>
            <input
              type="number"
              required
              step="0.01"
              min="0"
              placeholder="Enter Business Selling Price"
              name="business_selling_price"
              id="business_selling_price"
              className="input w-full"
              value={formData.business_selling_price}
              onChange={handleChange}
            />
          </div>
        </DialogContent>
        <DialogActions className="px-6 pb-4">
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            className="primaryBtn-contained"
            disabled={setDataToServer.isLoading}
          >
            {setDataToServer.isLoading ? (
              <Spinner className="w-5 h-5" />
            ) : (
              "Update Prices"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default QuickUpdatePriceModal;
